import { render, staticRenderFns } from "./uped.vue?vue&type=template&id=51883e60&scoped=true&"
import script from "./uped.vue?vue&type=script&lang=ts&"
export * from "./uped.vue?vue&type=script&lang=ts&"
import style0 from "./uped.vue?vue&type=style&index=0&id=51883e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51883e60",
  null
  
)

export default component.exports